(function(){
  angular.module('EdxClassroomReportModule')
    .directive('edxStudentLessonAlertsTable', function() {
      return {
        restrict: 'E',
        scope: {
          edxStudentAlerts: '=',
          edxNoAlertsMessage: '='
        },
        templateUrl: '/resources/components/report/classroom/at-a-glance/student-lesson-alerts-table.directive.html',
        controller: ['navigation', StudentLessonAlertsTableController],
        controllerAs: 'vm',
        bindToController: true
      };
    });

  function StudentLessonAlertsTableController(navigation) {
    var vm = this;
    vm.hrefForStudent = hrefForStudent;
    _onInit();

    // noinspection UnnecessaryReturnStatementJS
    return;

    function _onInit() {
      vm.tolPopoverText = '' +
        '<div><strong>Early Sense Making:</strong> Students begin developing conceptual understanding by interacting with manipulatives & relevant contexts.</div>' +
        '<div><strong>Looking for Structure & Relationships:</strong> Students think strategically to realize connections between concepts & representations.</div>' +
        '<div><strong>Fluency and Practice:</strong> Students strengthen mental strategies and practice skills in situations without manipulatives or scaffolding.</div>' +
        '';
    }

    function hrefForStudent(student) {
      return navigation.href({type: 'student', id: student.id});
    }
  }

})();